import * as angular from "angular";
import { MarkerService } from "../components/map/marker.helper";
import { User } from "../models/user.model";

export class OrganisationMapUserDataProvider {
    public users: User[] = [];
    public loadSize = 24;
    public mapListUsers = [];
    public searchPromise: any;
    public mapPromise: any;
    public loading = false;
    public filters = { search: "" };
    public listWidth = 3;
    public numLoadedItems = 0;
    public bounds = {};
    public zoom = null;
    public markers = [];
    public mapCountInBounds = null;
    public infiniteItems: OrganisationMapUserInfiniteItems;
    public error: any;

    public $q: any;
    public $http: any;
    public modelsUtils: any;
    public markerService: MarkerService;

    constructor(
        $q: any,
        MarkerService: MarkerService,
        $http: any,
        ModelsUtils: any
    ) {
        this.$q = $q;
        this.$http = $http;
        this.modelsUtils = ModelsUtils;

        this.markerService = MarkerService;

        this.infiniteItems = new OrganisationMapUserInfiniteItems(this);
    }

    setScreenSize(screenSize: string): void {
        if (screenSize == "lg") {
            this.listWidth = 3;
        } else if (screenSize == "md") {
            this.listWidth = 2;
        } else {
            this.listWidth = 1;
        }
        this.infiniteItems.reset();
        this.numLoadedItems = 0;
        this.mapListUsers.splice(0, this.mapListUsers.length);
    }

    setFilters(newFilters, bounds): void {
        this.bounds = bounds;
        this.filters = newFilters;
        this.infiniteItems.reset();
        this.infiniteItems.loading = false;
        this.numLoadedItems = 0;
        this.mapListUsers.splice(0, this.mapListUsers.length);
    }

    getAllMapListUsers(filter, lastValue, bounds): Promise<any> {
        const deferred = this.$q.defer();

        if (this.searchPromise) {
            this.searchPromise.resolve("user cancelled");
        }
        this.searchPromise = this.$q.defer();

        this.$http({
            url: "/v2/organisation/users",
            method: "GET",
            params: {
                filter: JSON.stringify(filter),
                last: lastValue,
                bounds: JSON.stringify(this.bounds),
            },
            timeout: this.searchPromise.promise,
        }).then(
            (response) => {
                if (response.data) {
                    let json = response["data"];
                    let nestedList = [];
                    this.numLoadedItems += json.data.length;
                    for (let i = 0; i < json.data.length; i++) {
                        if (nestedList.length < this.listWidth) {
                            nestedList.push(
                                this.modelsUtils.user(json.data[i])
                            );
                        } else {
                            this.mapListUsers.push(nestedList);
                            nestedList = [this.modelsUtils.user(json.data[i])];
                        }
                    }
                    if (nestedList.length < this.listWidth) {
                        if (this.listWidth - nestedList.length == 2) {
                            nestedList.push({});
                            nestedList.push({});
                        } else {
                            nestedList.push({});
                        }
                    }
                    this.mapListUsers.push(nestedList);
                    deferred.resolve(this.mapListUsers);
                } else {
                    deferred.reject(response);
                }
            },
            (error) => {
                deferred.reject(error);
            }
        );
        return deferred.promise;
    }

    getMapMarkers(): Promise<any> {
        this.loading = true;
        const deferred = this.$q.defer();
        if (this.mapPromise) {
            this.mapPromise.resolve("user cancelled");
        }
        this.mapPromise = this.$q.defer();

        this.$http({
            url: "/v2/organisation/map_users",
            method: "GET",
            params: {
                filter: JSON.stringify(this.filters),
                zoom: this.zoom,
                bounds: JSON.stringify(this.bounds),
            },
            timeout: this.mapPromise.promise,
        }).then(
            (response) => {
                let json = response["data"];
                this.mapCountInBounds = json.countInBounds;
                this.markers.splice(0, this.markers.length);

                angular.forEach(json.data, (user) => {
                    user = this.modelsUtils.user(user);
                    if (user.size > 1) {
                        this.markers.push(
                            this.markerService.generateClusterMarker(
                                user,
                                user.lat,
                                user.lng
                            )
                        );
                    } else {
                        this.markers.push(
                            this.markerService.generateUserMarker(
                                user,
                                user.lat,
                                user.lng
                            )
                        );
                    }
                });

                this.loading = false;
                deferred.resolve(this.markers);
            },
            (error) => {
                deferred.reject(error);
            }
        );
        return deferred.promise;
    }

    reset(): void {
        this.infiniteItems.reset();
    }
}

export class OrganisationMapUserInfiniteItems {
    public numLoaded_ = 0;
    public toLoad_ = 0;
    public loading = false;
    public dataProvider: OrganisationMapUserDataProvider;

    constructor(dataProvider: OrganisationMapUserDataProvider) {
        this.dataProvider = dataProvider;
    }

    getItemAtIndex(index: number): any {
        if (
            index * this.dataProvider.listWidth >
                this.dataProvider.mapCountInBounds ||
            !this.dataProvider.bounds ||
            !Object.keys(this.dataProvider.bounds).length
        ) {
            return null;
        }
        if (this.dataProvider.mapListUsers[index]) {
            return this.dataProvider.mapListUsers[index];
        }
        if (!this.loading) {
            this.fetchMoreItems_();
        }
        return null;
    }

    getLength(): number {
        return Math.ceil(
            this.dataProvider.mapCountInBounds / this.dataProvider.listWidth
        );
    }

    fetchMoreItems_(): void {
        this.loading = true;
        let offsetValue = null;
        this.toLoad_ = Math.ceil(
            (this.dataProvider.mapCountInBounds -
                this.numLoaded_ * this.dataProvider.listWidth) /
                this.dataProvider.listWidth
        );

        if (
            this.dataProvider.mapListUsers &&
            this.dataProvider.mapListUsers.length > 0
        ) {
            let lastList =
                this.dataProvider.mapListUsers[
                    this.dataProvider.mapListUsers.length - 1
                ];
            if (lastList.length) {
                let lastValue = lastList[lastList.length - 1];
                offsetValue = lastValue.uid;
            }
        }

        this.dataProvider
            .getAllMapListUsers(
                this.dataProvider.filters,
                offsetValue,
                this.dataProvider.bounds
            )
            .then((users) => {
                this.numLoaded_ = users.length;
                this.dataProvider.error = false;
                this.loading = false;
            }),
            (error) => {
                if (error.status != -1) {
                    this.dataProvider.error = true;
                    this.loading = false;
                }
            };
    }

    reset(): void {
        this.numLoaded_ = 0;
        this.toLoad_ = 0;
    }
}

angular
    .module("vcDataProvider")
    .service(
        "OrganisationMapUserDataProvider",
        OrganisationMapUserDataProvider
    );
